module.exports = __webpack_public_path__ + "img/renaissance_in_action.dd2668fe.jpg";